var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 27H21C22.6569 27 24 25.6569 24 24V9.41421C24 9.149 23.8946 8.89464 23.7071 8.70711L16.2929 1.29289C16.1054 1.10536 15.851 1 15.5858 1H7C5.34315 1 4 2.34315 4 4V24C4 25.6569 5.34315 27 7 27Z",
    stroke: "#3D3D3C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1V9C15 9.55228 15.4477 10 16 10H24",
    stroke: "#3D3D3C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14H19.5M8.5 17.5H19.5M8.5 21H14.2349",
    stroke: "#3D3D3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.7657d5e1e0480a0d614e617305822073.svg";
export { ForwardRef as ReactComponent };